import { Component } from '@angular/core';

@Component({
    selector: 'app-submissions-failure-dialog',
    templateUrl: './submissions-failure-dialog.component.html',
    styleUrls: ['./submissions-failure-dialog.component.scss'],
    standalone: false
})
export class SubmissionsFailureDialogComponent {

}
